import { __assign, __rest } from "tslib";
import React from 'react';
import { SVG } from '../svg/svg';
import { conditionalClassList } from '@at/formatter-utils/lib/class-name-utils/class-name.util';
import { StyledIcon } from './icon.styled';
import { iconConfig } from './icon-config';
/** NOTE: Please check whether the SVG/icon you're looking for is available in the package `@at/design-system-icons` [ATDS Icons Storybook](https://app.design-system.preprod.k8.atcloud.io/?path=/docs/icons-all-icons) */
export var Icon = function (_a) {
    var name = _a.name, size = _a.size, _b = _a.additionalClass, additionalClass = _b === void 0 ? '' : _b, svgContent = _a.svgContent, onClick = _a.onClick, onInteraction = _a.onInteraction, attributes = _a.attributes, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.backgroundSize, backgroundSize = _d === void 0 ? '48px 192px' : _d, otherHTMLProperties = __rest(_a, ["name", "size", "additionalClass", "svgContent", "onClick", "onInteraction", "attributes", "className", "backgroundSize"]);
    var classList = conditionalClassList("atds-icon atds-icon--".concat(size), additionalClass, className);
    var sizeObj = iconConfig();
    var sizeValue = sizeObj[size].size;
    var posValue = sizeObj[size].position;
    // Clean out px in string
    var cleanStringToNumber = parseInt(sizeValue) || undefined;
    var viewBox = cleanStringToNumber ? "0 0 ".concat(cleanStringToNumber, " ").concat(cleanStringToNumber) : undefined;
    var handleOnClick = function (event) {
        if (onInteraction)
            onInteraction();
        if (onClick)
            onClick(event);
    };
    return (React.createElement(StyledIcon, __assign({ as: SVG, svgContent: svgContent, viewBox: viewBox, title: name, width: cleanStringToNumber, height: cleanStringToNumber, styleHeight: sizeValue, styleWidth: sizeValue, backgroundPosition: posValue, className: classList, backgroundSize: backgroundSize, onClick: handleOnClick, attributes: {
            'aria-hidden': otherHTMLProperties['aria-hidden'],
        } }, attributes, otherHTMLProperties)));
};
